import StyledLink from '../StyledLink'
import useModule from '../../hooks/useModule'
import {
  CONTROLLER,
  MONITOR,
  RUNNER
} from '../routes'
import type { Props } from '../types'

const LinkToRunner = ({
  children,
  isHyperlink
}: Props) => {
  const [isMonitorFlag] = useModule()

  const base = !isMonitorFlag
    ? '/' + CONTROLLER + '/' + RUNNER
    : '/' + MONITOR + '/' + RUNNER

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      to={base}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToRunner
